var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useRef, useEffect } from "react";
import { Modal, ModalFooter, Button, Icon, Loading, MessageBanner, TextArea, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation, useQuery } from "react-query";
import { useCallout, useOkapiKy } from "@folio/stripes/core";
import { previewCoEditionAssign, assignCoEditionNumber, rejectCoEditionRequest, } from "../../api/coEditionRequestService";
import { deselectProductNumber } from "../../api/productNumberService";
import { extractBackendErrorMessages } from "../../utils/importErrors";
import css from "../title/EntityRow.module.css";
import { getErrorCode } from "../../utils/getErrorCode";
import { resolveAssignErrorMessageId } from "../../utils/newPrefixMagnitude";
import { getAssignNoticeMessageId } from "../../utils/productNumberAssignErrors";
import { useNewPrefixMagnitude } from "../../hooks/useNewPrefixMagnitude";
import { NewPrefixMagnitudeChoice } from "../productNumber/NewPrefixMagnitudeChoice";
export var CoEditionAssignModal = function (_a) {
    var requestId = _a.requestId, note = _a.note, initialMode = _a.initialMode, onClose = _a.onClose, onDone = _a.onDone, onError = _a.onError;
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var callout = useCallout();
    // Why the preview failed (e.g. the co-publisher has no ISBN/ISMN registration or prefix yet).
    var _b = useState(null), previewError = _b[0], setPreviewError = _b[1];
    var _c = useState(initialMode === "reject"), showReject = _c[0], setShowReject = _c[1];
    var _d = useState(""), rejectReason = _d[0], setRejectReason = _d[1];
    // Opening the modal previews the assignment, which reserves the number
    // (selected = true) server-side. Track that reserved id so we can release it
    // if the user closes or rejects without assigning — otherwise it stays
    // selected and the "next available number" lookup skips it, leaving a gap.
    var reservedProductNumberIdRef = useRef(null);
    var assignedRef = useRef(false);
    var _e = useQuery(["coEditionAssignPreview", requestId], function () { return previewCoEditionAssign(ky, requestId, { magnitude: 0 }); }, {
        enabled: !!requestId,
        cacheTime: 0,
        // A failed preview (404/422) is a state of the data, not a transient blip.
        retry: false,
        onSuccess: function (data) {
            var _a, _b;
            reservedProductNumberIdRef.current = (_b = (_a = data === null || data === void 0 ? void 0 : data.productNumber) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null;
            setPreviewError(null);
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var backendMessages, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, extractBackendErrorMessages(error)];
                    case 1:
                        backendMessages = _a.sent();
                        message = backendMessages.join(" ") ||
                            formatMessage({
                                id: "ui-br-agency.co-edition.assign.error.previewFailed",
                            });
                        setPreviewError(message);
                        // Toast only: the onError prop closes the modal, which would also take away "Zamítnout".
                        callout === null || callout === void 0 ? void 0 : callout.sendCallout({ type: "error", message: message });
                        return [2 /*return*/];
                }
            });
        }); },
    }), assignment = _e.data, isLoading = _e.isLoading;
    var releaseReservation = function () {
        var reservedId = reservedProductNumberIdRef.current;
        if (!reservedId || assignedRef.current) {
            return;
        }
        reservedProductNumberIdRef.current = null;
        // Best-effort cleanup: a failure here is covered by the server-side
        // scheduled safety-net, so we log rather than surface it to the user.
        deselectProductNumber(ky, reservedId).catch(function (error) {
            return console.error("Failed to release reserved product number:", error);
        });
    };
    var handleClose = function () {
        releaseReservation();
        onClose();
    };
    useEffect(function () {
        return function () {
            releaseReservation();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var needsPrefix = !!(assignment === null || assignment === void 0 ? void 0 : assignment.createNewPublisherPrefix);
    // Block size of a new prefix, capped by the publisher's production (FSD PP20) — smallest allowed preselected.
    var _f = useNewPrefixMagnitude(assignment === null || assignment === void 0 ? void 0 : assignment.maxMagnitude, assignment === null || assignment === void 0 ? void 0 : assignment.allowedMagnitudes), magnitude = _f.magnitude, setMagnitude = _f.setMagnitude;
    var automaticPrefixSize = !!(assignment === null || assignment === void 0 ? void 0 : assignment.newPrefixSizeAutomatic);
    var blockedMessageId = getAssignNoticeMessageId(assignment, {
        coEdition: true,
    });
    var noNumbersAvailable = !!assignment && !assignment.ready && !needsPrefix && !blockedMessageId;
    var assignMutation = useMutation(function () { return __awaiter(void 0, void 0, void 0, function () {
        var preview;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    if (needsPrefix) {
                        return [2 /*return*/, assignCoEditionNumber(ky, requestId, {
                                magnitude: automaticPrefixSize ? 0 : magnitude,
                            })];
                    }
                    return [4 /*yield*/, previewCoEditionAssign(ky, requestId, {
                            magnitude: 0,
                            publisherPrefixId: (_a = assignment === null || assignment === void 0 ? void 0 : assignment.publisherPrefix) === null || _a === void 0 ? void 0 : _a.id,
                            // Reuse the number already reserved when the modal opened so the server
                            // re-selects the same number instead of skipping it and reserving the
                            // next one (which would orphan the first and break the sequence).
                            productNumberId: (_b = assignment === null || assignment === void 0 ? void 0 : assignment.productNumber) === null || _b === void 0 ? void 0 : _b.id,
                        })];
                case 1:
                    preview = _g.sent();
                    reservedProductNumberIdRef.current =
                        (_d = (_c = preview.productNumber) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : reservedProductNumberIdRef.current;
                    return [2 /*return*/, assignCoEditionNumber(ky, requestId, {
                            magnitude: 0,
                            productNumberId: (_e = preview.productNumber) === null || _e === void 0 ? void 0 : _e.id,
                            publisherPrefixId: (_f = preview.publisherPrefix) === null || _f === void 0 ? void 0 : _f.id,
                        })];
            }
        });
    }); }, {
        onSuccess: function (result) {
            var _a, _b, _c;
            assignedRef.current = true;
            reservedProductNumberIdRef.current = null;
            onDone({
                action: "assigned",
                numberLabel: ((_a = result.productNumber) === null || _a === void 0 ? void 0 : _a.fullFormattedValue) ||
                    ((_b = result.productNumber) === null || _b === void 0 ? void 0 : _b.formattedValue) ||
                    ((_c = result.productNumber) === null || _c === void 0 ? void 0 : _c.value),
            });
        },
        onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
            var code;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorCode(error)];
                    case 1:
                        code = _a.sent();
                        onError(formatMessage({
                            id: resolveAssignErrorMessageId(code, "ui-br-agency.co-edition.assign.error.assignFailed", automaticPrefixSize),
                        }));
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var rejectMutation = useMutation(function () { return rejectCoEditionRequest(ky, requestId, { reason: rejectReason }); }, {
        onSuccess: function () {
            onDone({ action: "rejected" });
        },
        onError: function () {
            onError(formatMessage({
                id: "ui-br-agency.co-edition.assign.error.rejectFailed",
            }));
        },
    });
    var isBusy = assignMutation.isLoading || rejectMutation.isLoading;
    var canAssign = !!(assignment === null || assignment === void 0 ? void 0 : assignment.publisherId) &&
        !isBusy &&
        !noNumbersAvailable &&
        !blockedMessageId;
    var footer = (React.createElement(ModalFooter, null,
        showReject ? (React.createElement(React.Fragment, null,
            React.createElement(Button, { buttonStyle: "danger", disabled: isBusy, onClick: function () { return rejectMutation.mutate(); } },
                React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.assign.reject" })),
            initialMode !== "reject" && (React.createElement(Button, { disabled: isBusy, onClick: function () { return setShowReject(false); } },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.back" }))))) : (React.createElement(React.Fragment, null,
            React.createElement(Button, { buttonStyle: "primary", disabled: !canAssign, onClick: function () { return assignMutation.mutate(); } }, assignMutation.isLoading ? (React.createElement(React.Fragment, null,
                React.createElement(Icon, { icon: "spinner-ellipsis", size: "small" }),
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.saving" }))) : (React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.assign.submit" }))),
            React.createElement(Button, { disabled: isBusy, onClick: function () { return setShowReject(true); } },
                React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.assign.reject" })))),
        React.createElement(Button, { onClick: handleClose, disabled: isBusy },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" }))));
    return (React.createElement(Modal, { open: true, dismissible: true, onClose: handleClose, size: "small", label: formatMessage({
            id: showReject
                ? "ui-br-agency.co-edition.assign.modal.titleReject"
                : "ui-br-agency.co-edition.assign.modal.title",
        }), footer: footer }, !previewError && (isLoading || !assignment) ? (React.createElement(Loading, null)) : (React.createElement("div", { className: css.assignBody },
        previewError && (React.createElement(MessageBanner, { type: "error" }, previewError)),
        (assignment === null || assignment === void 0 ? void 0 : assignment.publisherName) && (React.createElement("div", { className: css.assignLine },
            React.createElement("span", { className: css.fieldLabel },
                React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.request.field.coPublisher" })),
            React.createElement("span", null, assignment.publisherName))),
        note && (React.createElement("div", { className: css.assignLine },
            React.createElement("span", { className: css.fieldLabel },
                React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.assign.field.note" })),
            React.createElement("span", null, note))),
        showReject ? (React.createElement(TextArea, { label: formatMessage({
                id: "ui-br-agency.co-edition.assign.field.rejectReason",
            }), value: rejectReason, onChange: function (event) {
                return setRejectReason(event.target.value);
            } })) : (assignment && (React.createElement(React.Fragment, null,
            blockedMessageId && (React.createElement(MessageBanner, { type: "warning" },
                React.createElement(FormattedMessage, { id: blockedMessageId }))),
            needsPrefix && !automaticPrefixSize && (React.createElement(NewPrefixMagnitudeChoice, { maxMagnitude: assignment.maxMagnitude, allowedMagnitudes: assignment.allowedMagnitudes, replacesUsedUpPrefix: assignment.replacesUsedUpPrefix, forCoPublisher: true, magnitude: magnitude, onChange: setMagnitude, name: "coEditionMagnitude", fieldsetClassName: css.magnitudeFieldset, hintClassName: css.assignHint })),
            noNumbersAvailable && (React.createElement(MessageBanner, { type: "warning" },
                React.createElement(FormattedMessage, { id: "ui-br-agency.title.products.panel.assign.noNumbers" }))),
            !needsPrefix && !noNumbersAvailable && !blockedMessageId && (React.createElement("div", { className: css.assignLine },
                React.createElement("span", { className: css.fieldLabel },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.product-number.assign.field.label.value" })),
                React.createElement("span", { className: css.assignValue }, assignment.assignedValue || "-"))))))))));
};
